@use '../../../../app/styles/common/colors';
@use '../../../../app/styles/common/mixins';

.description {
  margin-bottom: var(--spacing08);
  white-space: pre-line;
  overflow-wrap: break-word;

  @include mixins.laptop {
    margin-bottom: var(--spacing16);
  }
}

.translationWarning {
  margin-top: var(--spacing08);
  margin-bottom: var(--spacing06);
  color: colors.$fgSecondary;
  font-size: 16px;
  line-height: 24px;
}

.descriptionButtons {
  display: flex;
  align-items: center;
  gap: var(--spacing24);
}
